const $window = $(window)

/**
 * Check if we are currently on a mobile-sized device
 * @return {boolean} TRUE if the screen is small
 */
export function isOnSmallScreen() {
	return window.matchMedia('only screen and (max-width: 760px)').matches
}

let _isTouching = false
$window.one('touchstart', function () {
	_isTouching = true
})

export function isTouching() {
	return _isTouching
}